module.exports = __webpack_public_path__ + "img/pycodeeasy.17abda00.png";